module.exports = __webpack_public_path__ + "static/img/hold-queues.4a89593a.png";